import 'containers/common/Detail.css';
import OwnerSearch from "containers/owner/OwnerSearch";
import React, { Component } from "react";
import { Modal } from "react-bootstrap";





export default class OwnerSearchModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
         
            isLoading: true            
        };
     
       
    }
    

    async componentDidMount() {
        console.log("In OwnerSearchModal componentDidMount");
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        if (!this.props.show) {
            return null;
        }

           
    }

    


    renderComponent() {
        return (
            
            <Modal
                show={this.props.show}
                onHide={this.props.toggleOwnerSearchDialog}
                dialogClassName="modal-90w"
                >
                <Modal.Header closeButton>
                    <Modal.Title>Owner Index Search</Modal.Title>
                </Modal.Header>
                <Modal.Body>
           
                         <OwnerSearch
                                isAuthenticated={this.props.isAuthenticated}
                                user={this.props.user}
                                properties={this.props.properties}
                                controlType={this.props.controlType||"table2"}
                                buyerSellers={this.props.buyerSellers}
                                saleid={this.props.saleid}
                                ownerid={this.props.ownerid}
                                updateTableState={this.props.updateTableState}                                                    
                                saveRecord={this.props.saveRecord}
                                deleteRecord={this.props.deleteRecord}
                                refreshDataSet={this.props.refreshDataSet}
                                data={this.props.data}
                            />
          
                    </Modal.Body>
            </Modal>
        );
    }
    
    


    render() {
        return (

            <div className="OwnerSearchEdit">
                {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
            </div>
        );
    }
}
